import { usePermissionsRepository } from '@Hooks/useRepository';
import { MandantInfoRepository } from '@Repositories/Permissions';
import { isNullOrEmpty, unwrapOr } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';

export type MandantEntitlements = Partial<Record<string, string>>;

/**
 * Loads the entitlements granted to the current mandant.
 */
export function useMandantEntitlements(partnership: string | null) {
    const mandanten = usePermissionsRepository(MandantInfoRepository);

    const { data, isLoading, refetch } = useQuery<MandantEntitlements, unknown>({
        queryFn: async (): Promise<MandantEntitlements> => {
            const result = await mandanten.getEntitlements();
            return unwrapOr(result, {});
        },
        queryKey: ['mandanten', 'entitlements', partnership],
        enabled: !isNullOrEmpty(partnership),
        refetchOnWindowFocus: false,
    });

    return {
        entitlements: data,
        entitlementsLoading: isLoading,
        refetchEntitlements: async () => {
            await refetch();
        },
    };
}
